import { useContext } from "react"
import { BlogContext, BlogContextType } from "../provider/BlogProvider"
import BlogPostTile from "../../Feed/components/tiles/BlogPostTile"
import Pagination from "../../Common/Pagination/Pagination";

export default function BlogPosts() {
  const { blogPosts, totalRecords, currentPage, pageSize, loadItems } = useContext(BlogContext) as BlogContextType;

  return (
    <>
      <div className="grid-x grid-margin-x small-up-1 medium-up-1 large-up-2 blog-post-listing">
        { blogPosts.length > 0 && blogPosts.map((item) => (
          <BlogPostTile key={`blogPost-${item.id}`} node={item} defaultImage={null} />
        ))}
      </div>
      {<Pagination totalRecords={totalRecords} currentPage={currentPage} pageSize={pageSize} onPageChange={loadItems} />}
    </>
  )
}